// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/lock-thin-filled.svg';

export const LockThinFilled = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
